// extracted by mini-css-extract-plugin
export default {"button":"styles_button__2PZLk","container":"styles_container__fC1PG"};